export default __webpack_public_path__ + "static/media/Thor-silver.1ba68c01.png";